import { Component, ElementRef, input, ViewChild, AfterViewInit } from '@angular/core';
import { Tooltip } from 'flowbite';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [],
  templateUrl: './tooltip.component.html',
  styles: ``
})
export class TooltipComponent implements AfterViewInit {
  public title = input<string>('');
  public body = input.required<string>();
  public span = input<boolean>(false);
  public customClass = input<string>('');
  public placement = input<'top' | 'top-end'>('top');
  public id = crypto.randomUUID();

  @ViewChild('tooltipButton') private buttonRef!: ElementRef;
  @ViewChild('tooltipContent') private contentRef!: ElementRef;

  ngAfterViewInit() {
    new Tooltip(this.contentRef.nativeElement, this.buttonRef.nativeElement, {
      placement: this.placement()
    });
  }
}
